"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What is your typical response time?",
  answer: "We pride ourselves on efficiency. Our team typically responds to all inquiries within 24 business hours. For urgent project matters, our dedicated account managers are available for immediate support during standard operating hours."
}, {
  question: "Do you offer free initial consultations?",
  answer: "Yes, we offer a complimentary 30-minute strategy session to discuss your goals and determine how our services can best support your growth. This allows us to ensure a perfect alignment before moving forward."
}, {
  question: "How do I get started with your services?",
  answer: "Getting started is simple. You can reach out via our contact form or schedule a call directly. Once we understand your requirements, we'll provide a tailored proposal and a clear roadmap for your project's success."
}, {
  question: "Can you handle custom project requirements?",
  answer: "Absolutely. While we have proven frameworks, we understand that every business is unique. We specialize in creating bespoke solutions that integrate seamlessly with your existing workflows and long-term objectives."
}, {
  question: "What industries do you specialize in?",
  answer: "We work across a diverse range of sectors, including technology, professional services, and retail. Our versatile approach allows us to apply high-level strategic thinking to any industry-specific challenge."
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  return <section data-section-id="223642" id="contactfaq" className="w-full bg-background text-foreground py-24 md:py-32">
      <div ref={ref} className={`mx-auto max-w-3xl px-6 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-16 text-center">
          <h2 className="font-default text-4xl leading-tight text-foreground md:text-5xl font-bold tracking-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 font-default text-lg text-muted-foreground">
            Everything you need to know about our process and how we work together.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border py-2">
              <AccordionTrigger className="text-left font-default text-xl font-semibold text-foreground transition-colors hover:text-primary hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="pb-6 pt-2 font-default text-base leading-relaxed text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}